import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=70a13d7d&scoped=true&"
import script from "./ProfileMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=70a13d7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a13d7d",
  null
  
)

export default component.exports